module.exports = __webpack_public_path__ + "media/images/redesign-images/careers/careers-student-main-social-8f0a046a97658d578414c1ab4fc1019c.jpg";